import React, { useEffect } from 'react';
import { SupplierPaymentTable } from '../SupplierPaymentTable/SupplierPaymentTable';

import { useAppSelector, useAppDispatch } from '../../../../redux/store';
import { getSupplierPaymentMethods } from '../../../../redux/services/paymentsService';
import { SupplierScheduledPayments } from './SupplierScheduledPayments';
import './SupplierPayments.scss';

export const SupplierPayments = () => {
  const dispatch = useAppDispatch();

  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (user && currentSupplier?.id) {
      dispatch(getSupplierPaymentMethods({ supplierId: currentSupplier?.id || '' }));
    }
  }, [user?.id, currentSupplier?.id]);

  return (
    <div className="h-full pt-2 flex">
      <div className="w-full pt-2 flex flex-col min-h-0">
        {/* Matches SupplierPaymentTable's own px-4 so this sits on the same gutter as the summary
            cards and the table below it, rather than running full-bleed past them. */}
        <div className="px-4">
          <SupplierScheduledPayments />
        </div>
        <div className="flex-1 min-h-0">
          <SupplierPaymentTable />
        </div>
      </div>
    </div>
  );
};
